<template>
  <div
    v-for="ambition in ambitions"
    :key="ambition.id"
    class="mb-5"
  >
    <button
      class="ambition w-full rounded-full border py-2 pl-5 text-start font-bold lg:text-xl"
      :class="ambition === activeAmbtion ? 'active' : 'inactive'"
      @click="navigateTo(localePath({name: 'ambitions-ambition-slug', params: {ambition: ambition.parent?.slug, slug: ambition.slug}}));"
      type="button"
    >
      {{ ambition.title }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type {AmbitionQuery, AmbitionsQuery} from '~/graphql/graphql';

const props = defineProps<{
  activeAmbition: AmbitionQuery['ambition']
  ambitions: AmbitionsQuery['ambitions']
  color: string
}>();

const localePath = useLocalePath();

const activeAmbtion = computed(() => [...props.ambitions].find(ambition => ambition.slug === props.activeAmbition?.slug));
</script>

<style scoped>
.border {
  border-color: v-bind(color);
}

.ambition {
  @apply transition;

  &.inactive {
    background-color: #FFF6E9;
    color: v-bind(color);
  }

  &.active {
    background-color: v-bind(color);
    color: #FFFFFF;
  }

  &:hover {
    background-color: v-bind(color);
    color: #FFFFFF;
  }
}
</style>
